<div class="container">

    <div class="row" id="main-content">
        <h1 class="text-center">{{'COMMON.SESSION_TIMEOUT' | translate}}</h1>
    </div>
    <div class="row">
        <p class="text-center">{{'COMMON.RESTART_APPLICATION' | translate}}</p>
    </div>
    <div class="row">
        <button class="btn btn-primary restart-btn" (click)="restart()">{{'COMMON.RESTART' | translate}}</button>
    </div>
</div>